import styled from 'styled-components'

const Backdrop = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgb(0, 0, 0, 0.3);
`

export default Backdrop
